import Client from "../client";
import ConfigurationRepository from "./configurationRepository";
import {UpgradeConfigurationResource} from "client/resources/upgradeConfigurationResource";

class UpgradeConfigurationRepository extends ConfigurationRepository<UpgradeConfigurationResource> {
    constructor(client: Client) {
        super("UpgradeConfiguration", client);
    }
}

export default UpgradeConfigurationRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/upgradeConfigurationRepository.ts